const validateBookingPeriod = (invoiceDate: Date) => {
  const bookingPeriodStartDateString = localStorage.getItem("bookingPeriodStartDate")
  const bookingPeriodEndDateString = localStorage.getItem("bookingPeriodEndDate")
  if(!bookingPeriodStartDateString || !bookingPeriodEndDateString) return false
  const bookingPeriodStartDate = stringToDateObject(bookingPeriodStartDateString)
  const bookingPeriodEndDate = stringToDateObject(bookingPeriodEndDateString)
  return bookingPeriodStartDate <= invoiceDate.setHours(0,0,0,0)
    && bookingPeriodEndDate >= invoiceDate.setHours(0,0,0,0)
}   

const stringToDateObject = (dateString: string) => {
  return new Date(dateString).setHours(0,0,0,0)
}

export default validateBookingPeriod